export const productBrand = {
  productName: "EMO.coach",
  mechanicName: "ProofTree",
  productLockup: "EMO.coach ProofTree",
  tagline: "Coach your EQ. Prove your growth.",
  headline: "Your personal EQ coach and proof platform",
  shortHeadline: "Your personal EQ coach and proof platform",
  description:
    "EMO.coach helps you coach your emotional intelligence, log real-life proof, and earn portable badges for visible growth.",
}

export const screenCopy = {
  onboarding: {
    title: "Welcome to EMO.coach",
    subtitle: productBrand.shortHeadline,
    primaryAction: "Start Coaching Now",
    skipAction: "Skip",
  },
  home: {
    title: "Your EQ Journey",
    subtitle: "Keep coaching. Keep growing.",
    coachTip: "Your coach recommends: log one honest moment today, even if it felt imperfect.",
  },
  tree: {
    title: "EQ Skill Tree",
    subtitle: "Coach your soft skills, one level at a time",
  },
  skill: {
    subtitlePrefix: "Coach this skill",
    incomeTitle: "Why this skill matters",
  },
  proof: {
    title: "New Proof",
    subtitle: "Capture a real moment, then let your coach help you learn from it.",
    reflectionPrompt:
      "Name the feeling, the trigger, and one response you want to practice next time.",
  },
  tasks: {
    title: "Coaching Tasks",
    subtitle: "Turn daily practice into EQ progress",
  },
  passport: {
    title: "My EMO.coach Passport",
    subtitle: "Your proven growth. Ready to share.",
    shareAudience: "Built for clients, teams, employers, and collaborators.",
  },
}

export const skillIncomeExamples = [
  "Helps you navigate difficult conversations calmly, so deals and working agreements are less likely to break down under pressure.",
  "Builds trust with clients, teammates, and partners, making repeat work, referrals, and higher-responsibility roles easier to earn.",
  "Creates visible proof of growth that you can show an employer, investor, or client instead of relying on vague claims.",
]

export const nextImprovements = [
  "Make EMO.coach naming a single source of truth across screens and docs.",
  "Make Home the primary motivation screen through EQ Score, domains, and the next step.",
  "Strengthen Skill Tree with visual connections, completed-level counters, and quick entry points.",
  "Show each skill's practical value on Skill Detail.",
  "Keep Passport sharing focused on the implemented Supabase public profile path.",
  "Add empty states with icons and CTAs for search, tasks, proofs, and badges.",
  "Add subtle completed-level motion and success feedback in the proof flow.",
  "Unify header copy, spacing, and cards across primary routes.",
  "Add first-use hints without overloading the interface.",
  "Keep backend-backed and local fallback states explicit across the app.",
]
